<div class="box relative">
    <app-loader *ngIf="searching" loaderColor="default" loaderType="cover" overlayColor="white"></app-loader>

    <div class="h-100 relative inner">
        <div class="table-flex table-softer rounded o-hidden" [ngClass]="{ 'table-scroll': scrollbarYEnabled }">
            <div class="thead bg-softer">
                <div class="trow">
                    <div class="tcell small"></div>
                    <div class="tcell grow text-xs font-semi-bold text-muted" translate>v3-byoc-popup-create-course-mission-table-mission-name</div>
                    <div class="tcell grow text-xs font-semi-bold text-muted" translate>v3-byoc-popup-create-episode-course-table-created-by</div>
                </div>
            </div>
            <div #ps class="tbody" [perfectScrollbar]="{ suppressScrollX: true, wheelPropagation: false }" (psYReachEnd)="psYReachEnd()">
                <div class="trow" *ngFor="let newMission of newlyCreatedMissions">
                    <div class="tcell center small">
                        <!-- Radio -->
                        <div class="radio radio-success radio-single">
                            <input
                                [id]="'form-radio-table' + newMission.id"
                                type="radio"
                                [formControl]="missionIdControl"
                                [value]="newMission.id"
                                name="form-radio-table"
                                [formControlDataTest]="newMission.id"
                            />
                            <label [for]="'form-radio-table' + newMission.id">
                                <span class="icon" [inlineSVG]="'assets/icons.svg#dot'"></span>
                            </label>
                        </div>
                    </div>
                    <div class="tcell grow text-xs font-semi-bold">{{ newMission.name }}</div>
                    <div class="tcell grow text-xs font-semi-bold">{{ userName }}</div>
                </div>
                <div class="trow" *ngFor="let mission of missions">
                    <div class="tcell center small">
                        <!-- Radio -->
                        <div class="radio radio-success radio-single">
                            <input
                                [id]="'form-radio-table' + mission.id"
                                type="radio"
                                [formControl]="missionIdControl"
                                [value]="mission.id"
                                name="form-radio-table"
                                [formControlDataTest]="mission.id"
                            />
                            <label [for]="'form-radio-table' + mission.id">
                                <span class="icon" [inlineSVG]="'assets/icons.svg#dot'"></span>
                            </label>
                        </div>
                    </div>
                    <div *ngIf="!isMissionInactive(mission); else inactiveMissionLink" class="tcell grow text-xs font-semi-bold">
                        <a [routerLink]="['/library', 'mission', mission.id]" [target]="'_blank'" class="pointer">
                            <span class="text-hover-info">
                                {{ mission.name }}
                            </span>
                        </a>
                    </div>
                    <ng-template #inactiveMissionLink>
                        <div class="tcell grow text-xs font-semi-bold">
                            <span>
                                {{ mission.name }}
                            </span>
                        </div>
                    </ng-template>
                    <div class="tcell grow text-xs font-semi-bold">
                        {{ mission.original ? ('v3-global-socialtalent' | translate) : mission.user.name + ' ' + mission.user.lastName }}
                    </div>
                </div>
                <div *ngIf="noResults" class="py-5 font-semi-bold text-xs text-center" translate>v3-byoc-popup-create-course-mission-table-empty</div>
            </div>
        </div>
    </div>
</div>
